<template>
  <div
    class="d-inline-block"
    :style="{
      '--color': `var(--${colorVariant}-color)`,
    }"
  >
    <div class="circle-container">
      <div
        v-for="circle in 4"
        :key="circle"
        class="circle"
        :class="{ active: count >= circle }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CircleSelector",
  props: {
    count: {
      default: 1,
      type: Number,
    },

    colorVariant: {
      default: "primary",
      type: String,
    },
  },
};
</script>

<style scoped>
.circle-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.circle {
  width: 1.1rem;
  height: 1.1rem;
  border: 0.2rem solid var(--color);
  border-radius: 50%;
  background-color: white;
  transition: background-color 0.3s;
}

.circle.active {
  background-color: var(--color);
}
</style>
